import { useEffect, useRef } from "react";
import { GoalCard } from "@client/features/cards/card-face";
import type { PlayerProjection } from "@saboteur/contracts";
import "@client/components/personal-card.css";

export function GoalPeek({
  peekedGoal,
  onClose,
}: {
  peekedGoal: PlayerProjection["self"]["inspectedGoals"][number] | undefined;
  onClose: () => void;
}) {
  const peekDialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (peekedGoal && !peekDialog.current?.open) peekDialog.current?.showModal();
  }, [peekedGoal]);
  return (
    <dialog
      ref={peekDialog}
      className="personal-card map-peek"
      aria-labelledby="map-peek-title"
      onClose={() => onClose()}
    >
      <button
        type="button"
        className="personal-card__close"
        aria-label="Close map"
        onClick={() => peekDialog.current?.close()}
      >
        ×
      </button>
      <h2 id="map-peek-title">A secret peek</h2>
      {peekedGoal ? (
        <>
          <GoalCard face={peekedGoal.truth} />
          <p>{peekedGoal.truth === "GOLD" ? "Gold!" : "Just rock."}</p>
        </>
      ) : null}
      <button
        type="button"
        className="personal-card__hide"
        onClick={() => peekDialog.current?.close()}
      >
        Hide card
      </button>
    </dialog>
  );
}
